"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var parentElements = function parentElements(element) {
  var parents = [];

  while (element) {
    var tagName = element.nodeName.toLowerCase();
    var cssId = element.id ? "#".concat(element.id) : '';
    var cssClass = element.className ? ".".concat(element.className.replace(/\s+/g, '.')) : '';
    parents.unshift({
      element: element,
      selector: tagName + cssId + cssClass
    });
    element = element.parentNode !== document ? element.parentNode : false;
  }

  return parents;
};

var nthElement = function nthElement(element) {
  var c = element;
  var nth = 0;

  while (c.previousElementSibling !== null) {
    if (c.nodeName === element.nodeName) {
      nth++;
    }

    c = c.previousElementSibling;
  }

  return nth;
};

var nthSelectorNeeded = function nthSelectorNeeded(selector, path) {
  var querySelector = path === '' ? selector : "".concat(path, " > ").concat(selector);
  return document.querySelectorAll(querySelector).length > 1;
};

var buildPathString = function buildPathString(parents) {
  var pathArr = [];
  parents.forEach(function (parent) {
    if (nthSelectorNeeded(parent.selector, pathArr.join(' > '))) {
      parent.selector += ":nth-of-type(".concat(nthElement(parent.element), ")");
    }

    pathArr.push(parent.selector);
  });
  return pathArr.join(' > ');
};

var domElementPath = function domElementPath(element) {
  if (!(element instanceof HTMLElement)) {
    throw new Error('element must be of type `HTMLElement`.');
  }

  return buildPathString(parentElements(element));
};

var _default = domElementPath;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// /home/oksana/sites/bermad/bermad-theme/node_modules/dom-element-path/dist/dom-element-path.js
// module id = 28
// module chunks = 0